import { useLanguage } from "../../utils/localization/languages/I18nContext";
import { Language } from "../../utils/localization/languages/types";
import { languageSpecificPath } from "../../utils/routing/pathHelpers";
import useFetchModalData from "../../utils/useFetchModalData";
import { CruiseCardModalModalDataQuery } from "types/graphql-types";

const cruiseCardLocalizedModalPath = (
  cruiseCode: string | undefined,
  language: Language
) => {
  return cruiseCode
    ? languageSpecificPath(`/${cruiseCode}`, language, "/cruise-cards")
    : undefined;
};

export const useStaticCruiseCard = (cruiseCode?: string) => {
  const language = useLanguage();
  const path = cruiseCardLocalizedModalPath(cruiseCode, language);
  return useFetchModalData<CruiseCardModalModalDataQuery>(path);
};
